import { TextInputField } from "@sainsburys-tech/luna-form";
import { Form, CheckboxField } from "@sainsburys-tech/luna-form";
import { Container, GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { FC, useEffect, useState } from "react";
import {
  AutomationAdaptoSystemOptions,
  FIELDS,
  FormInputLevels,
  HazardousCodeOptions,
  MUTypeOptions,
} from "../../../Interfaces/Product/IProductFormField";
import { ProductFormProps } from "../../../Types/Product/ProductFormProps";
import ActionButton from "../../SharedComponents/ActionButton";
import { useSelector } from "react-redux";
import { SelectField } from "@sainsburys-tech/luna-form";
import { UI_CONSTANTS } from "../../../Constants/constants";

const AttributeForm: FC<ProductFormProps> = (props) => {
  const emptyReplacer = (key: any, value: any) => {
    if (value === "") {
      return null;
    }
    return value;
  };

  const payload = useSelector((state: any) => state.popupReducer);
  const isInitialState =
    JSON.stringify(payload?.data?.editPayload?.values, emptyReplacer) ===
    JSON.stringify(props.values, emptyReplacer);

  return (
    <>
      <Container>
        <Form className="o-form">
          <GridWrapper className="ln-u-push-bottom">
            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.sainId.name}
                label={FormInputLevels.SainId}
                maxLength={128}
                value={props.values.sainId}
                error={props.errors?.sainId}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
                disabled={true}
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <TextInputField
                name="displayItemNumber"
                label={FormInputLevels.DisplayItemNumber}
                value={
                  props.values.skuNumber
                    ? props.values.skuNumber
                    : props.values.catNumber
                }
                disabled={true}
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.description.name}
                label={FormInputLevels.Description}
                maxLength={128}
                value={props.values.description}
                error={props.errors?.description}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
                disabled={true}
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.packSize.name}
                label={FormInputLevels.PackSize}
                value={
                  props.values.alias === UI_CONSTANTS.SAINSBURYS_SKU ||
                  props.values.alias === UI_CONSTANTS.SAINSBURYS_PACK
                    ? `CS${props.values.packSize}`
                    : props.values.alias === UI_CONSTANTS.ARGOS
                    ? (props.values.packSize == 1) ? `EA` : `CS${props.values.packSize}`
                    : props.values.packSize
                }
                disabled
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <SelectField
                name={FIELDS.muType.name}
                label={FormInputLevels.MUType}
                options={MUTypeOptions}
                defaultValue={props.values.muType}
                onChange={props.onChange}
                onBlur={props.onBlur}
                placeholder="NONE"
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <CheckboxField
                label={<p></p>}
                outlined
                name={FIELDS.uglies.name}
                options={[{ value: "Uglies", label: FormInputLevels.Uglies }]}
                defaultChecked={props.values.uglies}
                onClick={(e: any) => {
                  props.onChange(e, "", "", true);
                }}
                fullWidth
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <CheckboxField
                label={<p></p>}
                name={FIELDS.twoPersonLift.name}
                outlined
                options={[
                  {
                    value: "TwoPersonLift",
                    label: FormInputLevels.TwoPersonLift,
                  },
                ]}
                defaultChecked={props.values.twoPersonLift}
                onClick={(e: any) => {
                  props.onChange(e, "", "", true);
                }}
                fullWidth
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <CheckboxField
                label={<p></p>}
                name={FIELDS.hazardous.name}
                outlined
                options={[
                  { value: "Hazardous", label: FormInputLevels.Hazardous },
                ]}
                defaultChecked={props.values.hazardous}
                onClick={(e: any) => {
                  props.onChange(e, "", "", true);
                }}
                fullWidth
              />
            </GridItem>

            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <SelectField
                name={FIELDS.hazardousCode.name}
                label={FormInputLevels.HazardousCode}
                options={HazardousCodeOptions}
                defaultValue={props.values.hazardousCode}
                value={props.values.hazardousCode}
                onChange={props.onChange}
                onBlur={props.onBlur}
                disabled={!props.values.hazardous}
                placeholder="NONE"
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <CheckboxField
                label={<p></p>}
                name={FIELDS.nestedItem.name}
                outlined
                options={[
                  {
                    value: "NestedItem",
                    label: FormInputLevels.NestedItem,
                  },
                ]}
                defaultChecked={props.values.nestedItem}
                onClick={(e: any) => {
                  props.onChange(e, "", "", true);
                }}
                fullWidth
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.nestIncrement.name}
                label={FormInputLevels.NestIncrement}
                maxLength={128}
                value={props.values.nestIncrement}
                error={props.errors?.nestIncrement}
                onBlur={props.onBlur}
                onChange={props.onChange}
                disabled={!props.values.nestedItem}
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <SelectField
                name={FIELDS.automationAdaptoSystem.name}
                label={FormInputLevels.AutomationAdaptoSystem}
                options={AutomationAdaptoSystemOptions}
                defaultValue={props.values.automationAdaptoSystem}
                value={props.values.automationAdaptoSystem}
                onChange={props.onChange}
                onBlur={props.onBlur}
                placeholder="NONE"
              />
            </GridItem>

            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.automationToteFill.name}
                label={FormInputLevels.AutomationToteFill}
                maxLength={128}
                value={props.values.automationToteFill}
                error={props.errors?.automationToteFill}
                onBlur={props.onBlur}
                onChange={props.onChange}
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.automationMinTotes.name}
                label={FormInputLevels.AutomationMinTotes}
                maxLength={128}
                value={props.values.automationMinTotes}
                error={props.errors?.automationMinTotes}
                onBlur={props.onBlur}
                onChange={props.onChange}
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <CheckboxField
                label={<p></p>}
                name={FIELDS.highRisk.name}
                className="checkBoxOrange"
                outlined
                options={[
                  {
                    value: "HighRisk",
                    label: FormInputLevels.HighRisk,
                  },
                ]}
                defaultChecked={props.values.highRisk}
                disabled
                fullWidth
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
              <CheckboxField
                label={<p></p>}
                name={FIELDS.strapTotes.name}
                className="checkBoxOrange"
                z
                outlined
                options={[
                  {
                    value: "StrapTotes",
                    label: FormInputLevels.StrapTotes,
                  },
                ]}
                defaultChecked={props.values.strapTotes}
                disabled
                fullWidth
              />
            </GridItem>
            {props.values.alias === UI_CONSTANTS.ARGOS && (

              <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
                <CheckboxField
                  label={<p></p>}
                  name={FIELDS.expiryDateRequired.name}
                  outlined
                  options={[
                    {
                      value: "ExpiryDateRequired",
                      label: FormInputLevels.ExpiryDateRequired,
                    },
                  ]}
                  defaultChecked={props.values.expiryDateRequired}
                  onClick={(e: any) => {
                    props.onChange(e, "", "", true);
                  }}
                  fullWidth
                />
              </GridItem>
                 )}
              <GridItem size={{ sm: "1/4", xs: "1" }}>
                <CheckboxField
                  label={<p></p>}
                  name={FIELDS.pickPack.name}
                  outlined
                  options={[
                    {
                      value: "PickPack",
                      label: FormInputLevels.PickPack,
                    },
                  ]}
                  defaultChecked={props.values.pickPack}
                  onClick={(e: any) => {
                    props.onChange(e, "", "", true);
                  }}
                  fullWidth
                />
              </GridItem>
            </GridWrapper>
        </Form>

        <ActionButton
          onSubmit={props.onSubmit}
          onClearAll={props.onClearAll}
          onCancel={props.onCancel}
          isAddDisabled={isInitialState}
          isDirty={props.dirty}
          isEdit={props.isEdit}
          isClearButtonRequired={false}
          submitted={props.submitted}
        />
      </Container>
    </>
  );
};

export default AttributeForm;
